export default "__VITE_ASSET__DrrnEg2S__"